import { render } from "./EventLabels.vue?vue&type=template&id=1ce8b5db"
import script from "./EventLabels.vue?vue&type=script&lang=js"
export * from "./EventLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__